import React ,{useEffect,useState}from "react";
import shape21 from "../../images/shape-21.png";
import logo from "../../images/logonew.png";
import shape22 from "../../images/shape-22.png";
import { Link } from "react-router-dom";
import axios from "axios";

const Footer = ({pass, username}) => {
  const today = new Date();
  const [notLogged, setNotLogged] = useState(true);
  const toQbank = `https://maps-medics.web.app/${username}/${pass}`;
  const loggedIn = "https://maps-medics.web.app/";
  const toLogIn = `/login`;
  useEffect(() => {
    console.log(pass, username);
    if (sessionStorage.getItem("user_id")) {
      axios
        .get(
          "https://maps-medics-be.onrender.com/check_log/" +
            sessionStorage.getItem("user_id") + "/" + sessionStorage.getItem("token") )
        .then((res) => {
          if (res.data.success === true) {
            setNotLogged(false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div class="section footer-section" style={{ padding: 0, margin: 0 }}>
        <div class="footer-widget-section">
          {/* <img class="shape-1 animation-down" src={shape21} alt="Shape"/> */}
          <div class="container">
            <div class="row">
              {/* <div className="col-lg-1"></div> */}
              <div class="col-lg-6 col-md-6 order-md-1 order-lg-1">
                <div class="footer-widget">
                  <div
                    class="widget-logo"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Link to="/">
                      <img src={logo} style={{ width: "90%" }} alt="Logo" />
                    </Link>
                  </div>
                  <div className="row">
                    <div class="footer-widget">
                      <div class="widget-subscribe">
                        <ul
                          class="widget-social"
                          style={{ justifyContent: "center" }}
                        >
                          <li>
                            <a href="#">
                              <i class="fa-brands fa-facebook-f"></i>
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <i class="fa-brands fa-twitter"></i>
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <i class="fa-brands fa-instagram"></i>
                            </a>
                          </li>
                          <li>
                            <a href="">
                              <i class="fa-brands fa-linkedin"></i>
                            </a>
                          </li>
                          <li>
                            <a href="">
                              <i class="fa-brands fa-youtube"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="col-lg-6 col-md-6 order-md-2 order-lg-3"
                style={{ marginTop: "1px" }}
              >
                <div className="container p-3">
                  <div className="row p-2">
                    <div className="col">
                      <h6>
                        {" "}
                        <span className="footerlikeNav">
                          <Link
                            to="/"
                            style={{
                              textDecoration: "none",
                              color: "#000",
                              fontFamily: "Playfair Display",
                              fontWeight: "700",
                              fontSize: "16px",
                            }}
                          >
                            Home
                          </Link>{" "}
                        </span>{" "}
                      </h6>
                    </div>
                    <div className="col">
                      <h6>
                        {" "}
                        <span className="footerlikeNav">
                          <Link
                            to="/courses"
                            style={{
                              textDecoration: "none",
                              color: "#000",
                              fontFamily: "Playfair Display",
                              fontWeight: "700",
                              fontSize: "16px",
                            }}
                          >
                            Courses
                          </Link>
                        </span>{" "}
                      </h6>
                    </div>
                    <div className="col">
                      <h6>
                        <span className="footerlikeNav">
                        {sessionStorage.getItem("logged_once") ? (
                      <a  style={{
                        textDecoration: "none",
                        color: "#000",
                        fontFamily: "Playfair Display",
                        fontWeight: "700",
                        fontSize: "16px",
                      }}
                        onClick={() =>
                          sessionStorage.setItem("logged_toqbank", true)
                        }
                        href={toQbank}
                        // style={{ color: "#fff", textDecoration: "none" }}
                      >
                         QBank
                      </a>
                    ) : (
                      <a
                        href={notLogged === true ? toLogIn : loggedIn}
                        onClick={() => {
                          console.log(sessionStorage.getItem("user_id"));
                        }}
                        style={{
                          textDecoration: "none",
                          color: "#000",
                          fontFamily: "Playfair Display",
                          fontWeight: "700",
                          fontSize: "16px",
                        }}
                        // style={{ color: "#fff", textDecoration: "none" }}
                      >
                        {" "}
                        QBank
                      </a>
                    )}
                          {/* <Link
                            to="/QBankAdver"
                            style={{
                              textDecoration: "none",
                              color: "#000",
                              fontFamily: "Playfair Display",
                              fontWeight: "700",
                              fontSize: "16px",
                            }}
                          >
                            {" "}
                            QBank
                          </Link>{" "} */}
                        </span>{" "}
                      </h6>
                    </div>
                    <div className="col">
                      <h6>
                        {" "}
                        <span className="footerlikeNav" style={{paddingLeft:'8%'}}> 
                          <Link
                            to="/blog"
                            style={{
                              textDecoration: "none",
                              color: "#000",
                              fontFamily: "Playfair Display",
                              fontWeight: "700",
                              fontSize: "16px",
                            }}
                          >
                            {" "}
                            Blog
                          </Link>{" "}
                        </span>{" "}
                      </h6>
                    </div>
                  </div>
                  <div className="row p-2 footerMobileView">
                    <div className="col-md-3 aboutSmall">
                      <h6>
                        <span className="footerlikeNav">
                          <Link
                            to="/about"
                            style={{
                              textDecoration: "none",
                              color: "#000",
                              fontFamily: "Playfair Display",
                              fontWeight: "700",
                              fontSize: "16px",
                            }}
                          >
                            About Us
                          </Link>{" "}
                        </span>
                      </h6>
                    </div>
                    <div className="col-md-5 termsSmall" >
                      <h6>
                        {" "}
                        <span className="footerlikeNav">
                          <Link
                            to="/terms"
                            style={{
                              textDecoration: "none",
                              color: "#000",
                              fontFamily: "Playfair Display",
                              fontWeight: "700",
                              fontSize: "16px",
                            }}
                          >
                            Terms & Conditions
                          </Link>{" "}
                        </span>
                      </h6>
                    </div>
                    <div className="col-md-3 contactSmall" style={{paddingRight:'0', paddingLeft:'16px'}}>
                      <h6>
                        <span className="footerlikeNav">
                          <Link
                            to="/contact"
                            style={{
                              textDecoration: "none",
                              color: "#000",
                              fontFamily: "Playfair Display",
                              fontWeight: "700",
                              fontSize: "16px",
                            }}
                          >
                            Contact Us
                          </Link>{" "}
                        </span>
                      </h6>

                      {/* <Link to='/contact'>    <h6  class="btn btn-primary " style={{backgroundColor:'#FFC600', border:'#FFC600', borderRadius:'20px'}}>Contact Us</h6></Link> */}
                    </div>
                  </div>
                </div>

                {/* <div className="container" style={{display:'flex',justifyContent:'center'}}>

<div class="widget-address">
                                <Link to='/contact'>    <button  class="btn btn-primary " style={{backgroundColor:'#FFC600', border:'#FFC600', borderRadius:'20px'}}>Contact Us</button></Link>

                                </div>

</div>                      */}
              </div>
            </div>
          </div>
          {/* <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-6 order-md-1 order-lg-1">

                <div class="footer-widget" style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                    <div class="widget-logo">
                        <a href="#"><img src={logo} alt="Logo"/></a>
                    </div>

                </div>

            </div>
       
        </div>
    </div> */}

          {/* <img class="shape-2 animation-left" src={shape22} alt="Shape"/> */}
        </div>

        <div
          class="footer-copyright"
          style={{ backgroundColor: "transparent" }}
        >
          <div className="container" style={{ marginTop: "1px" }}>
            <div
              className="row p-2"
              style={{ display: "flex", justifyContent: "center" }}
            >
              {/* <div className="col-md-6 ">
              <div className="row" style={{ display: "block" }}>
                <a
                  href="https://neoneg.com/"
                  target="_blank"
                  style={{
                    textDecoration: "none",
                    cursor: "pointer",
                    color: "white",
                  }}
                >
                  www.neoneg.com
                </a>
              
              </div>
            </div> */}
              <div
                className="col-md-12"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <p
                  style={{
                    margin: "0",
                    fontSize: "15px",
                    lineHeight: "1.8",
                    fontWeight: "700",
                    fontFamily: "Segoe UI",
                    color: "#000",
                  }}
                >
                  Copyright &copy; {today.getFullYear()} by{" "}
                  <span>
                    {" "}
                    <a
                      target="_blank"
                      href="https://neoneg.com/"
                      style={{
                        cursor: "pointer",
                        textDecoration: "none",
                        color: "#000",
                        fontWeight: "700",
                      }}
                    >
                      NEON
                    </a>{" "}
                  </span>
                  <a
                    href=""
                    style={{
                      textDecoration: "none",
                      fontWeight: "700",
                      color: "#000",
                    }}
                    onClick={() => {
                      window.open(`https://wa.me/+201113588988`);
                    }}
                  >
                    <i
                      className="fa-brands fa-whatsapp fs-5"
                      style={{ color: "#000", marginRight: "10px" }}
                    ></i>
                  </a>{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
